module.exports = __webpack_public_path__ + "static/img/byxwTitle.901e099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/byxwTitle.png
// module id = Y89s
// module chunks = 2